import { runtime } from '../runtime';
import { openExternal as openWebExternal } from './web';

export async function openExternal(url) {
    const parsed = new URL(url);
    if (!['https:', 'http:'].includes(parsed.protocol)) throw new Error('Unsupported external URL');
    if (!runtime.isNative()) return openWebExternal(url);
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
}
